import { environment } from "../../../environments/environment"
import { HttpMethodsTypeEnum } from "./admin-base.constant"

const BASE_URL = environment.apiUrl
const IDENTITY = "/identity"
const VERSION = "/api/v1"
const ORGANIZATION_API = "/organization/api/v1/organization"
const SUPER_ADMIN_API = "/organization/api/v1/superadmin"
const ORGANIZATION = "/organization"
const PUBLIC = "/public" + VERSION
const REPORTS = "/reports"
const TRIP = "/trip"
const TRIP_REPORTS = "/trip-reports"
const TRIP_API = "/trip/api/v1"
const ORGANIZATION_CONVENIENCE_FEE_API = "/organization/api/v1"
const SINGLE_INVOICE = "/single-invoice"
const SINGLE_INVOICES = "/single-invoices"

export class AdminApi {
	static CREATE_ORGANIZATION_DATA(
		POST: HttpMethodsTypeEnum,
		CREATE_ORGANIZATION_DATA: any,
		params: any,
		Authorised_HttpOptions: {
			headers: import("@angular/common/http").HttpHeaders
		},
		arg4: boolean,
		arg5: boolean,
	): import("rxjs").Observable<any> {
		throw new Error("Method not implemented.")
	}
	// Authentication related
	public static LOGIN = BASE_URL + IDENTITY + "/login"
	public static LOGOUT = BASE_URL + IDENTITY + "/logout"
	public static CHANGE_PASSWORD = BASE_URL + "/identity/changepassword"

	// Forgot password flow
	public static FORGOT_PASSWORD_GENERATE_OTP =
		BASE_URL + IDENTITY + "/public/password/forgot"
	public static FORGOT_PASSWORD_SUBMIT_OTP =
		BASE_URL + IDENTITY + "/public/password/forgot/verify"
	public static FORGOT_PASSWORD_RESET_PASSWORD =
		BASE_URL + IDENTITY + "/public/password/reset"

	// Organization
	public static INVITE_ORGANIZATION = BASE_URL + ORGANIZATION_API + "/invite"
	public static ORGANIZATION_LIST = BASE_URL + ORGANIZATION_API + "/list"
	public static RESEND_ORGANIZATION_INVITE =
		BASE_URL + ORGANIZATION_API + "/invite/resend"
	public static ORGANIZATION_STATUS =
		BASE_URL + ORGANIZATION_API + "/profile/status/update"
	public static ORGANIZATION_DETAILS =
		BASE_URL + ORGANIZATION_API + "/profile/get"
	public static CREATING_ORGANISATION_DATA =
		BASE_URL + TRIP_API + "/settings/settings/createOrganization"

	public static UPDATING_ORGANISATION_DATA =
		BASE_URL + TRIP_API + "/settings/settings/:organizationId"
	public static GET_ALL_ORG_DATA = BASE_URL + TRIP_API + "/settings/allorg"
	public static GET_CRONLIST_DATA = BASE_URL
	public static GET_ORG_DATA_BY_ID = BASE_URL + TRIP_API + "/settings"
	public static UPLOAD_ORGANIZATION_SETTING_CSV = BASE_URL + TRIP_API + "/settings/upload-csv"

	public static ORGANIZATION_TYPE =
		BASE_URL + ORGANIZATION + PUBLIC + "/organization-types"
	public static ORGANIZATION_SIZE =
		BASE_URL + ORGANIZATION + PUBLIC + "/organization-size"
	public static INDUSTRY_LIST =
		BASE_URL + ORGANIZATION + PUBLIC + "/industry-list"

	public static COUNTRY_LIST =
		BASE_URL + ORGANIZATION + PUBLIC + "/country-list"
	public static STATE_LIST = BASE_URL + ORGANIZATION + PUBLIC + "/state-list"
	public static CITY_LIST = BASE_URL + ORGANIZATION + PUBLIC + "/city-list"

	public static CREATE_ORG_CUSTOM_LIST = BASE_URL + ORGANIZATION_API + "/:orgId/dynamic-list"
	public static GET_ORG_CUSTOM_LIST_SAMPLE = BASE_URL + ORGANIZATION_API + "/:orgId/dynamic-list/sample"
	public static GET_ORG_CUSTOM_LIST = BASE_URL + ORGANIZATION_API + "/:orgId/dynamic-list"
	public static GET_ORG_CUSTOM_LIST_OPTIONS = BASE_URL + ORGANIZATION_API + "/:orgId/dynamic-list/:dynamic_list_id/options"
	public static UPDATE_ORG_CUSTOM_LIST = BASE_URL + ORGANIZATION_API + "/:orgId/dynamic-list/:dynamic_list_id"

	//Super admin profile
	public static SUPER_ADMIN_PROFILE =
		BASE_URL + SUPER_ADMIN_API + "/profile/get"

	//Report
	public static CLIENT_REPORT_LIST =
		BASE_URL + ORGANIZATION + VERSION + REPORTS + "/client-report"
	public static CLIENT_REPORT_DOWNLOAD =
		BASE_URL + ORGANIZATION + VERSION + REPORTS + "/client-report/download"

	public static FIGHT_STATISTICS_REPORT_LIST =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/flight-statistics"
	public static FIGHT_STATISTICS_REPORT_DOWNLOAD =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/flight-statistics/download"

	public static TRANSACTION_REPORT_LIST =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/transaction-data"
	public static TRANSACTION_REPORT_DOWNLOAD =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/transaction-data/download"

	public static SERVICE_WISE_TRIPS_REPORT_LIST =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/service-wise-trips"
	public static SERVICE_WISE_TRIPS_REPORT_DOWNLOAD =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/service-wise-trips/download"

	public static INVOICE_REPORT_LIST =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/customer-wise-invoice"
	public static INVOICE_REPORT_LIST2 =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/customer-wise-invoice2"
	public static INVOICE_REPORT_DOWNLOAD =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/customer-wise-invoice/download"
	public static INVOICE_REPORT_DOWNLOAD2 =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/customer-wise-invoice2/download"
	public static INVOICE_REPORT_BULK_DOWNLOAD =
		BASE_URL +
		TRIP_REPORTS +
		VERSION +
		REPORTS +
		"/customer-wise-invoice/download-invoices"
	public static INVOICE_REPORT_BULK_DOWNLOAD2 =
		BASE_URL +
		TRIP_REPORTS +
		VERSION +
		REPORTS +
		"/customer-wise-invoice/download-invoices2"

	public static HOTEL_STATISTICS_REPORT_LIST =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/hotel-statistics"
	public static HOTEL_STATISTICS_REPORT_DOWNLOAD =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/hotel-statistics/download"

	//Airports list
	public static AIRPORT_LIST = BASE_URL + TRIP + PUBLIC + "/airports"
	public static AIRLINES_LIST = BASE_URL + TRIP + PUBLIC + "/airlines"
	public static HOTEL_CITIES = BASE_URL + TRIP + VERSION + "/hotel/cities"

	public static HOTEL_DATA_CHARGE_MASTER_REPORT_LIST =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/hotel-data-charge"
	public static HOTEL_DATA_CHARGE_MASTER_REPORT_DOWNLOAD =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/hotel-data-charge/download"

	public static FLIGHT_DATA_CHARGE_MASTER_REPORT_LIST =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/flight-data-charge"
	public static FLIGHT_DATA_CHARGE_MASTER_REPORT_DOWNLOAD =
		BASE_URL + TRIP_REPORTS + VERSION + REPORTS + "/flight-data-charge/download"

	// Services Settings

	public static UPDATING_SERVICE_DATA_BY_ID =
		BASE_URL + TRIP_API + "/services/putService"

	public static GETTING_INVENTORY_LIST =
		BASE_URL + TRIP_API + "/services/getServicesall"
	public static CREATING_FACILITYACCESS_DATA =
		BASE_URL + TRIP_API + "/services/updateFacilityAccess"
	public static GETTING_CHARGES_LIST =
		BASE_URL + ORGANIZATION_CONVENIENCE_FEE_API + "/convenience-fee/charges"
	public static UPDATING_CHARGESLIST_DATA =
		BASE_URL +
		ORGANIZATION_CONVENIENCE_FEE_API +
		"/convenience-fee/updateFee"
	public static WALLET_CREDIT = BASE_URL + TRIP_API + "/walletCredit"
	public static WALLET_CREDIT_BALANCE =
		BASE_URL + TRIP_API + "/walletCredit/balance"

	// Resume paused bookings for an organization (POST)
	public static WALLET_CREDIT_RESUME_PAUSED_BOOKINGS =
		BASE_URL + TRIP_API + "/walletCredit/resume-paused-bookings"

	// Dashboard settings
	public static UPDATE_DASHBOARD_SETTINGS =
		BASE_URL + TRIP_API + "/settings/dashboard/:organizationId"
	public static GET_DASHBOARD_SETTINGS =
		BASE_URL + TRIP_API + "/settings/dashboard/:organizationId"
	public static UPDATE_DASHBOARD_COMPONENTS =
		BASE_URL + TRIP_API + "/settings/dashboard-components/:orgId"
	public static CREATE_DASHBOARD_COMPONENTS =
		BASE_URL + TRIP_API + "/settings/dashboard-components/create/:orgId"

	public static EXPENSE_WISE_INVOICE_LIST =
		BASE_URL + SINGLE_INVOICE + VERSION + SINGLE_INVOICES + "/expense-wise-invoice"
	// Single invoicing list with "Split by Traveler" ON: one record per traveler
	public static readonly TRAVELLER_WISE_INVOICE_LIST =
		BASE_URL + SINGLE_INVOICE + VERSION + SINGLE_INVOICES + "/traveller-wise-report"
	// A company's enabled Text additional employee fields: the report's extra filters
	public static readonly ADDITIONAL_EMPLOYEE_FIELDS =
		BASE_URL + SINGLE_INVOICE + VERSION + SINGLE_INVOICES + "/additional-employee-fields/:organizationId"
	public static SELECTED_EXPENSE_WISE_INVOICE_REPORT_DOWNLOAD =
		BASE_URL +
		SINGLE_INVOICE +
		VERSION + SINGLE_INVOICES +
		"/expense-wise-invoice/download"
	public static GENERATE_SINGLE_INVOICE_EXPENSE =
		BASE_URL +
		SINGLE_INVOICE +
		VERSION +
		SINGLE_INVOICES +
		"/expense-wise-invoice/generate"
	public static GET_GENERATED_SINGLE_INVOICES =
		BASE_URL +
		SINGLE_INVOICE +
		VERSION +
		SINGLE_INVOICES +
		"/generated-single-invoice-expenses"
	public static DELETE_GENERATED_SINGLE_INVOICE =
		BASE_URL +
		SINGLE_INVOICE +
		VERSION +
		SINGLE_INVOICES +
		"/generated-single-invoice-expenses/delete"
	public static GROUPED_INVOICE_REPORT_DOWNLOAD =
		BASE_URL +
		SINGLE_INVOICE +
		VERSION +
		SINGLE_INVOICES +
		"/grouped-single-invoice-report/download"
	public static UPDATE_SINGLE_INVOICE_EXPENSE =
		BASE_URL +
		SINGLE_INVOICE +
		VERSION +
		SINGLE_INVOICES +
		"/expense-wise-invoice/update"

	public static INVOICE_URL_DOWNLOAD =
		BASE_URL +
		SINGLE_INVOICE +
		VERSION +
		SINGLE_INVOICES +
		'/expense-wise-invoice/download-generated-pdf'

	public static DOWNLOAD_ETICKETS_ZIP =
		BASE_URL +
		TRIP +
		VERSION +
		SINGLE_INVOICES +
		'/download-etickets-zip'
	public static DOWNLOAD_GENERATED_ETICKETS =
		BASE_URL +
		SINGLE_INVOICE +
		VERSION +
		SINGLE_INVOICES +
		'/expense-wise-invoice/download-generated-etickets'
	public static INVOICE_EXCEL_DOWNLOAD =
		BASE_URL +
		SINGLE_INVOICE +
		VERSION +
		SINGLE_INVOICES +
		'/expense-wise-invoice/download-generated-excel'
	
}
